<template>
  <div id="scrEnd" class="align">
<!--    <IconBase viewBox="0 0 68 68">-->
<!--      <icon></icon>-->
<!--    </IconBase>-->
    <p class="ln3">{{scrMsg}}</p>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: "scrEndScoringError",
    components: {
      // IconBase: () => import('@/components/svg/IconBase'),
      // icon: () => import('@/components/svg/icon'),
    },
    mounted(){

      window.scrollTo({
        left:0,
        top:this.$parent.$refs.formAlign.offsetTop,
        behavior: 'smooth'
      });
    },
    computed:{
      ...mapState({
        scrMsg: state => state.Form.system.scrMsg,
      }),
    }
  }
</script>

<style scoped>
  #scrEnd{text-align: center;padding: 15vw 0;background: white;}
  svg{width: 22vw;height: 22vw;}
.ln1{    font-size: 7vw;font-weight: bold;padding-top: 8vw;}
.ln2{font-size: 5.6vw;padding: 2vw 0;}
.ln3{color:#869A95;font-size: 5vw}
@media screen and (min-width: 760px) {
  #scrEnd{padding: 8vw 0;}
  svg{width: 6vw;height: 6vw;}
  .ln1{font-size: 2vw;padding-top: 3vw;}
  .ln2{font-size: 1.6vw;padding: 1vw 0;}
  .ln3{font-size: 1.4vw;}
}
@media screen and (min-width: 1140px) {
  #scrEnd{padding: 40px 0;}
  svg{width: 68px;height: 68px;}
  .ln1{font-size: 22px;padding-top: 40px;}
  .ln2{font-size: 18px;padding: 15px 0;}
  .ln3{font-size: 16px;}
}
</style>
